import React from 'react';

import type { Text } from '@zillow/constellation';
import { FormField, Input, Label, Textarea } from '@zillow/constellation';

import type { Section } from '../../../../models';
import { WATER_BILLING } from '../../../../constants';
import WaterBilling from './WaterBilling';
import { CenteredHR } from '../../../Widgets/CenteredHR';
import type { HTMLElementEvent } from '../../../../models/Types';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function WaterBilling_v2({ setSectionValues, section }: Props) {
  function onLateFeeChange(event: HTMLElementEvent<typeof Text>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [WATER_BILLING.FIELD_NAME.LATE_FEES]: value,
    });
  }
  function onProviderChange(event: HTMLElementEvent<typeof Text>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [WATER_BILLING.FIELD_NAME.PROVIDER]: value,
    });
  }
  function onChargesChange(event: HTMLElementEvent<typeof Text>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [WATER_BILLING.FIELD_NAME.CHARGES]: value,
    });
  }
  return (
    <WaterBilling section={section} setSectionValues={setSectionValues}>
      <>
        <CenteredHR />
        <FormField
          marginBottom="sm"
          label={<Label>What administrative fees or late fees will be assessed?</Label>}
          control={
            <Textarea
              value={section.getFieldValue(WATER_BILLING.FIELD_NAME.LATE_FEES)}
              onChange={onLateFeeChange}
              resize="vertical"
            />
          }
        />
        <FormField
          marginBottom="sm"
          optional
          label={<Label>Who is the submeter billing provider that will provide the submeter billing service?</Label>}
          control={
            <Input value={section.getFieldValue(WATER_BILLING.FIELD_NAME.PROVIDER)} onChange={onProviderChange} />
          }
        />
        <FormField
          marginBottom="sm"
          label={
            <Label>
              How will the submeter bills, including fixed charges and variable charges, be calculated and apportioned?
            </Label>
          }
          control={
            <Textarea
              value={section.getFieldValue(WATER_BILLING.FIELD_NAME.CHARGES)}
              onChange={onChargesChange}
              resize="vertical"
            />
          }
        />
      </>
    </WaterBilling>
  );
}

WaterBilling_v2.description = 'Asks if the unit has a water submeter with additional fields for San Diego';

export default WaterBilling_v2;
